import UserLayout from '@/components/Layouts/UserLayout'
import BlankLayout from '@/components/Layouts/BlankLayout'
// import BasicLayout from '@/components/Layouts/BasicLayout'
import RouteView from '@/components/Layouts/RouteView'
import PageView from '@/components/Layouts/PageView'

export { 
  UserLayout, 
  BlankLayout, 
  // BasicLayout,
  RouteView, 
  PageView 
}

//此处未引入BasicLayout.vue组件，因为会导致单元测试报错，初步推断是引入有些混乱


// WEBPACK FOOTER //
// ./src/components/Layouts/index.js